export default "__VITE_ASSET__37oQvqIf__"